var _span, _div;
import React, { forwardRef, lazy, Suspense } from 'react';
import { LazyImage, ProgressBar } from '@crehana/compass.ui';
import { cx } from 'class-variance-authority';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LazyPlayroomRewardIndicatorWithRive = /*#__PURE__*/lazy(function () {
  return import("../CardCoins").then(function (module) {
    return {
      "default": module["default"]
    };
  });
});
var ImageCard = function ImageCard(_ref, ref) {
  var backgroundImgParams = _ref.backgroundImgParams,
    backgroundImg = _ref.backgroundImg,
    title = _ref.title,
    subtitle = _ref.subtitle,
    bottomElement = _ref.bottomElement,
    onCTAClick = _ref.onCTAClick,
    className = _ref.className,
    labelState = _ref.labelState,
    progress = _ref.progress,
    coins = _ref.coins;
  return /*#__PURE__*/_jsxs("button", {
    className: cx('tw-relative tw-overflow-hidden tw-rounded-2 tw-min-h-14.4 tw-flex tw-flex-col tw-justify-end',
    // Background overlay
    "after:content-[''] after:tw-absolute after:tw-top-0 after:tw-left-0 after:tw-w-full after:tw-h-full after:tw-z-1 after:tw-bg-neutral-dark-800 after:tw-opacity-20",
    // Hover shadow
    'tw-transition-shadow tw-duration-200 tw-ease-in-out hover:tw-shadow-02 dark:tw-shadow-elevation-dark-02',
    // Group
    'tw-group', className),
    type: "button",
    onClick: onCTAClick,
    "aria-label": title,
    "data-testid": "content-category-card",
    ref: ref,
    children: [labelState && /*#__PURE__*/_jsx("span", {
      className: "tw-bg-info-400 tw-w-fit tw-font-pop tw-text-1.2 tw-font-semibold tw-mb-auto tw-ml-2.4 tw-px-1 tw-py-0.4 tw-relative tw-rounded-full tw-text-neutral-light-100 tw-top-2.4 tw-z-2",
      children: labelState
    }), backgroundImg && /*#__PURE__*/_jsx(LazyImage, {
      src: backgroundImg,
      alt: title,
      className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-z-0 group-hover:tw-scale-105 tw-transition-transform tw-duration-500 tw-ease-in-out",
      imgClassName: "tw-object-cover tw-w-full tw-h-full",
      imgxParams: {
        fit: 'crop',
        crop: 'faces',
        q: (backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.quality) || 100,
        w: backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.width,
        h: backgroundImgParams === null || backgroundImgParams === void 0 ? void 0 : backgroundImgParams.height
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-z-2 tw-text-neutral-light-100 tw-p-1.6 md:tw-p-2.4 tw-text-left",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-text-2.4 tw-font-pop tw-font-semibold tw-leading-2.8 tw-mb-0.8 tw-line-clamp-2 sm:tw-line-clamp-3",
        children: title
      }), !!subtitle && /*#__PURE__*/_jsx("div", {
        className: "tw-font-body3",
        children: subtitle
      }), /*#__PURE__*/_jsxs("div", {
        className: cx('tw-flex tw-items-center tw-mt-1.2', {
          'tw-hidden': !progress
        }),
        children: [/*#__PURE__*/_jsx(ProgressBar, {
          detailBackground: {
            background: 'tw-bg-neutral-dark-600',
            progressBar: 'tw-bg-warning-300'
          },
          progress: progress !== null && progress !== void 0 ? progress : 0,
          size: "s",
          className: "tw-rounded-2.4 !tw-w-8 tw-h-0.8 tw-relative [&>span]:tw-rounded-0 tw-mr-1.2"
        }), coins && coins > 0 && /*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(LazyPlayroomRewardIndicatorWithRive, {
            coins: coins
          })
        })]
      }), !!bottomElement && /*#__PURE__*/_jsxs("div", {
        className: "tw-hidden md:tw-block tw-overflow-hidden tw-max-h-0 group-hover:tw-max-h-8",
        style: {
          transition: 'max-height 0.5s ease-in-out'
        },
        children: [_span || (_span = /*#__PURE__*/_jsx("span", {
          className: "tw-h-0.1 tw-w-full tw-block tw-mt-1 tw-bg-neutral-light-100 tw-opacity-20"
        })), /*#__PURE__*/_jsx("div", {
          className: "tw-line-clamp-3 tw-mt-0.8 tw-leading-2.2 tw-font-light",
          children: bottomElement
        })]
      })]
    }), _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-transition-opacity tw-duration-500 tw-ease-in-out tw-absolute tw-w-full tw-h-full tw-opacity-0 group-hover:tw-opacity-50 tw-bg-neutral-light-800"
    }))]
  });
};
export default /*#__PURE__*/forwardRef(ImageCard);